/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const NewColorIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={size} height={size} {...props}><rect width={20} height={20} x={2} y={2} fill="#FF493F" rx={10} /><path fill="#F7F7F7" d="M15.687 7.581v8.838H14.1l-3.882-5.615h-.073v5.615H8.313V7.58h1.612l3.857 5.615h.086V7.581z" /></svg>;
};
export default NewColorIcon;